"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_CHAINS = exports.MIN_ABIS = exports.NETWORKS = exports.NATIVE_ADDRESS = void 0;
exports.NATIVE_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
exports.NETWORKS = {
    1: {
        name: 'Ethereum',
        chainId: 1,
        explorer: 'https://etherscan.io',
    },
    42161: {
        name: 'Arbitrum One',
        chainId: 42161,
        explorer: 'https://arbiscan.io',
    },
    8453: {
        name: 'Base',
        chainId: 8453,
        explorer: 'https://basescan.org',
    },
    43114: {
        name: 'Avalanche',
        chainId: 43114,
        explorer: 'https://snowtrace.io',
    },
    137: {
        name: 'Polygon',
        chainId: 137,
        explorer: 'https://polygonscan.com',
    },
};
exports.MIN_ABIS = {
    name: 'function name() view returns (string)',
    symbol: 'function symbol() view returns (string)',
    decimals: 'function decimals() view returns (uint8)',
    totalSupply: 'function totalSupply() view returns (uint256)',
    approve: 'function approve(address spender, uint256 value) external returns (bool success)',
    allowance: 'function allowance(address owner, address spender) external view returns (uint256)',
};
exports.AVAILABLE_CHAINS = Object.keys(exports.NETWORKS).map((c) => Number(c));
//# sourceMappingURL=web3.js.map